// external
import Config from '../../utils/config';

// internal
import { valid, invalid } from '../../utils/validators/resolutions';
import stripDelimiter from '../../utils/strip-delimiter-from-currency';

import { region, brand } from '../../localizations/current-locale';
import { dynamicBrand } from '../../utils/brand';

// eslint-disable-next-line import/no-dynamic-require
let messages;
import(`../../utils/text-resources/${dynamicBrand()}/${region}/messages`).then((m) => {
  messages = m.default;
});

const validateMonthlySalaryAfterTax = (input = '', ...props) => {
  const cleanedInput = stripDelimiter(input);
  const config = Config.getValues();

  if (!/\S+/.test(cleanedInput || '')) {
    return (props[2] === 'applicant.monthlyIncomeAfterTax'
      ? invalid(messages.monthlySalaryAfterTaxRequired)
      : invalid(messages.coApplicantMonthlyIncomeAfterTaxRequired));
  }

  if (!/^(-?\d+)$/.test(cleanedInput)) {
    return (props[2] === 'applicant.monthlyIncomeAfterTax'
      ? invalid(messages.monthlySalaryOnlynumbers)
      : invalid(messages.coApplicantMonthlySalaryOnlynumbers));
  }

  const value = parseInt(cleanedInput, 10);

  const minSalary = config.RESTRICTIONS.MIN_SALARY;

  const incomeBeforeTax = parseInt(
    stripDelimiter(props[0].applicant.monthlyIncomeBeforeTax), 10);
  const coApplicantIncomeBeforeTax = parseInt(
    stripDelimiter(props[0].coApplicant.monthlyIncomeBeforeTax), 10);

  if ((incomeBeforeTax < value && props[2] === 'applicant.monthlyIncomeAfterTax')
  || (coApplicantIncomeBeforeTax < value && props[2] === 'coApplicant.monthlyIncomeAfterTax')) {
    return invalid(messages.monthlySalaryAfterTaxInvalid);
  }

  if (value < minSalary) {
    return (props[2] === 'applicant.monthlyIncomeAfterTax'
      ? invalid(messages.monthlySalaryTooLow, { minSalary, brand })
      : invalid(messages.coApplicantMonthlySalaryTooLow, { minSalary, brand }));
  }

  return valid();
};

export default validateMonthlySalaryAfterTax;
